export function isLoading(state = false, action) {
  switch (action.type) {
    case 'CONTENT_LOADING':
      return action.isLoading

    default:
      return state
  }
}

export function tokenInfo(state = {}, action) {
  switch (action.type) {
    case 'TOKEN_INFO':
      return action.tokens

    default:
      return state
  }
}

export function isAuth(state = false, action) {
  switch (action.type) {
    case 'USER_AUTH':
      return action.isAuth

    default:
      return state
  }
}

export function usersInfo(state = [], action) {
  switch (action.type) {
    case 'USERS_INFO':
      return action.users

    default:
      return state
  }
}

export function controllersInfo(state = [], action) {
  switch (action.type) {
    case 'CONTROLLERS_INFO':
      return action.controllers

    default:
      return state
  }
}

export function eventsInfo(state = [], action) {
  switch (action.type) {
    case 'EVENTS_INFO':
      return action.events
    default:
      return state
  }
}

export function groupsInfo(state = [], action) {
  switch (action.type) {
    case 'GROUPS_INFO':
      return action.groups
    default:
      return state
  }
}
